import DataService from '@/service/DataService'

const version = JSON.parse(localStorage.getItem('version'))

const state = version
  ? { version }
  : { version: null }

const getters = {
};

const actions = {
  // GET
  ping({commit, rootState, dispatch, state}) {
    return DataService.checkConnection()
      .then(res => {
        if (res.data != state.version) {
          commit("NEUEVERSION", res.data)

          if (rootState.Benutzer.benutzer) {
            dispatch("fetchBenutzer")
          }
        }
      })
  }
};

const mutations = {
  NEUEVERSION: (state, version) => {
    state.version = version
    localStorage.setItem('version', JSON.stringify(version))
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}